import { NewBingoForm } from "./components/form-components/new-bingo-form"
import "./App.css"
const NewBingoPage = () => {
    return <main className="formApp"><NewBingoForm></NewBingoForm></main>
}

export default NewBingoPage